export const pointsBalanceImg = require('@/assets/pointsBalance.png');
export const projectImg = require('@/assets/project.png');
export const requstImg = require('@/assets/requst.png');
export const userImg = require('@/assets/user.png');
export const technicalImg = require('@/assets/technical.png');
export const opinionImg = require('@/assets/opinion.png');
export const bookImg = require('@/assets/book.png');
export const contrastImg = require('@/assets/contrast.png');


// userInfo Header
export const purchasePoints = require('@/assets/purchasePoints.png')
export const membership = require('@/assets/membership.png')
export const logOut = require('@/assets/logOut.png')
export const myOrder = require('@/assets/myOrder.png')
export const website = require('@/assets/website.png')
export const accountSettings = require('@/assets/accountSettings.png')


// 官网首页
export const bookHomeImg = require('@/assets/images/book.png')
export const AIHomeImg = require('@/assets/images/AI.png')
export const newHomeImg = require('@/assets/images/new.png')
export const lijieHomeImg = require('@/assets/images/lijie.png')
export const contrastHomeImg = require('@/assets/images/contrast.png')

// 官网功能
export const bookCeHomeImg = require('@/assets/images/bookCe.png')
export const AISearchHomeImg = require('@/assets/images/AISearch.png')
export const newIdedHomeImg = require('@/assets/images/newIded.png')
export const reviedHomeImg = require('@/assets/images/revied.png')



// banner图
export const BannerImg = require('@/assets/banner.png')

//积分
export const contrast3HomeImg = require('@/assets/contrast3.png')
export const contrast4HomeImg = require('@/assets/contrast4.png')
export const book3HomeImg = require('@/assets/book3.png')
export const book4HomeImg = require('@/assets/book4.png')
export const searchOA1HomeImg = require('@/assets/searchOA1.png')
export const searchOA2HomeImg = require('@/assets/searchOA2.png')
export const technical1Img = require('@/assets/technical1.png');
export const technical2Img = require('@/assets/technical2.png');


export const iconWord = require('@/assets/fileIcon/word.png')
export const iconPdf = require('@/assets/fileIcon/PDF.png')
export const iconTXT = require('../assets/fileIcon/txt.png')
export const iconMD = require('@/assets/fileIcon/md.png')
export const iconMARKDOWN = require('@/assets/fileIcon/markdown.png')
export const iconHTML = require('@/assets/fileIcon/HTML.png')
export const iconXLSX = require('@/assets/fileIcon/xlsx.png')
export const iconXLS = require('@/assets/fileIcon/xls.png')
export const iconCSV = require('@/assets/fileIcon/csv.png')
export const iconEML = require('@/assets/fileIcon/EML.png')
export const iconMSG = require('@/assets/fileIcon/msg.png')
export const iconPPTX = require('@/assets/fileIcon/pptx.png')
export const iconPPT = require('@/assets/fileIcon/PPT.png')
export const iconXML = require('@/assets/fileIcon/XML.png')
export const iconEPUB = require('@/assets/fileIcon/epub.png')
export const iconPicture = require('@/assets/fileIcon/picture.png')


// 官网局图
export const mapImg1 = require('@/assets/images/home1.png')
export const mapImg2 = require('@/assets/images/home2.png')
export const mapImg3 = require('@/assets/images/chuang.png')



